/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import $ from 'jquery';
import lodashfilter from 'lodash/filter';
import { RCUtils } from './../../RCUtils';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import uniq from 'lodash/uniq';
import * as Autosuggest from 'react-autosuggest';
import { SpecificBookingDetails } from '../childcomponents/SpecificBookingDetails';
import { SpecificBookingReefers } from '../childcomponents/SpecificBookingReefers';
import { SpecificBookingReeferCommonData } from '../childcomponents/SpecificBookingReeferCommonData';
import { SpecificBookingReefersGridData } from '../childcomponents/SpecificBookingReefersGridData';
import * as RCNGWindow from './../sharedcomponents/ConfirmationWindow';
import ReeferStatus from '../routecomponents/ReeferStatus';
import { ReeferStatusGrid } from '../childcomponents/ReeferStatusGrid';
import { ReeferStatusSSRMGrid } from '../childcomponents/ReeferStatusSSRMGrid';
import { Server } from 'net';
import moment from 'moment';
import forEach from 'lodash/forEach';
import DateFormat from 'dateformat';

var Config: any = require('../../Config.json');

var self;
var selReefers;
var lastCheckedNodes = [];
var lastCheckedParentNode = "";
var selectedReefers = "";
var selectedUnits = "";

interface WizardState {
    renderHtml: any;
    BookingDetails: server.BookingDetails;
    BookingReefers: server.BookingSearchDetails;
    CommonBookingData: server.CommonBookingData;
    rowData: server.bookingReefer[];
    disassociaterowData: server.bookingReefer[];
    Thirdparty: server.ThirdParty[];
    CargoCareProfiles: any[];
    RefTemperatureUnit: server.RefTemperatureUnit[];
    isEdit: boolean;
    tabFrom: number;
    currentTab: number;
    AllBooking: any[];
    BookingCount: number;
    BookingType: any;
    IsOpen: any;
    buttonState: any;
    formname: any;
    isViewOnly: boolean;
}

var emptyBookingDetails: server.BookingDetails = {
    Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '', VesselETD: null, VesselETA: null, BLNumber: '', ContractParty: '', Consolidation: '',
    Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
    SelectedVesselCD: '',
    SelectedCall: '',
    SelectedVoyage: '',
    ArrSelectedVesselCD: '',
    ArrSelectedCall: '',
    ArrSelectedVoyage: '', userInput: 0,
    CustomerAccessGroupIDLoaded:'',
    BKCustomer:''
};
var emptyBookingReefers: server.BookingSearchDetails = {
    BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [], BookingNumber:[]
}
var emptyCommonBookingData: server.CommonBookingData = {
    ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: '', BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
    HighValueCargo: 'none', CargoCareProfile: '', ThirdPartyAccess: '', CACTNotRequired: false, CTRequire: false, CARequire: false, CACTDifferByReefer: false,
    CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
    O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName: ''
};
export class NewBookingEdit extends React.Component<RouteComponentProps<{}>, WizardState> {
    constructor(props: any) {
        super(props);
        this.resetAllDetails();
        this.state = {
            renderHtml: '',
            BookingDetails: emptyBookingDetails,
            BookingReefers: emptyBookingReefers,
            CommonBookingData: emptyCommonBookingData,
            rowData: [],
            Thirdparty: [],
            CargoCareProfiles: [],
            RefTemperatureUnit: [],
            disassociaterowData: [],
            isEdit: true,
            tabFrom: 1,
            currentTab: 1,
            AllBooking: [],
            BookingCount: 0,
            BookingType: 'Edit Booking',
            IsOpen: 'Edit',
            buttonState: true,
            formname: '',
            isViewOnly: false
        };

        self = this;
        //var newBookingDetails = emptyBookingDetails;
        //var cDate = moment(this.dateTypeFormatter(new Date())).format('LLL');
        //var active = new Date(cDate);
        //newBookingDetails.VesselETA = DateFormat(active, 'mm/dd/yyyy HH:MM:ss');
        //newBookingDetails.VesselETD = DateFormat(active, 'mm/dd/yyyy HH:MM:ss');
        //this.setState({
        //    BookingDetails: newBookingDetails
        //});

    }
    dateTypeFormatter(eventDate: Date) {
        //written considering parameter 'eventDate' sent is IST
        var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
        var eventdttm = new Date();
        if (eventDate != null)
            eventdttm = new Date(eventDate.toString());
        var utc = eventdttm.getTime() + (eventdttm.getTimezoneOffset() * 60000);
        var prefDateTime = new Date(new Date(utc).getTime() + (60000 * (parseInt(timeZoneOffset))));
        return prefDateTime;
    }
    resetAllDetails() {
        emptyBookingDetails = {
            Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '', VesselETD: null, VesselETA: null, BLNumber: '', ContractParty: '', Consolidation: '',
            Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
            SelectedVesselCD: '',
            SelectedCall: '',
            SelectedVoyage: '',
            ArrSelectedVesselCD: '',
            ArrSelectedCall: '',
            ArrSelectedVoyage: '', userInput: 0,CustomerAccessGroupIDLoaded:'', BKCustomer:''
        }
        emptyBookingReefers = { BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [], BookingNumber:[] }
    }
    updatemyBookingDimensions() {
        $("#BookingTabsHeight").css('min-height', $(window).height() - 150);
        $("#BookingTabsHeight").css('max-height', $(window).height() - 150);
    }
    componentDidMount() {
        var authRight = RCUtils.CheckAssesRightsOnly('212');
        if (!authRight) { this.props.history.push('/AccessDenied'); } else {
            this.updatemyBookingDimensions();
            window.addEventListener("resize", this.updatemyBookingDimensions.bind(this));
            $("#SubscriptionMenu li").click(function (e) {
                e.preventDefault();
                return false;
            });
            $('.deploymentWizard').find("ul.nav li:nth-child(0)").attr("href", "#menu1");
            //if (this.props.location.state != null && this.props.location.state != undefined) {
            //if (this.props.location.state != 0) {
            //this.getBookingDetails(this.props.location.state);
            // }
            //}
            //else
            //if (self.props.formname == "ReeferStatus" ||self.props.formname == "ReeferStatusGrid") {
            //        $('#globalLoader').show();
            //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetbookingDataByNumber?BookingNumber=' + self.props.reeferData[0].BookingNumber)
            //        fetch(request)
            //            .then(RCUtils.handleError)
            //            .then(response => response.json() as Promise<server.BookingDataByNumber[]>)
            //            .then(data => {
            //                $('#globalLoader').hide();
            //                if (data != null && data != undefined && data.length > 0) {
            //                    this.setState({ AllBooking: data }, () => { this.EditBooking(); });
            //                }

            //            });

            //}
            //else
            //    this.setState({ renderHtml: this.dynamicRendering(1) });
            this.getdata(self.props);
        }
    }
    componentWillReceiveProps(nextprops: any) {
        this.setActiveAndInactiveOld(1, 0);
        this.setState({
            BookingDetails: emptyBookingDetails,
            BookingReefers: emptyBookingReefers,
            tabFrom: 1,
            currentTab: 1
        }, () => { this.getdata(nextprops); });
    }
    getdata(params: any) {
        if (params.location.state != null && (params.location.state.formname == "ReeferStatus" || params.location.state.formname == "ReeferStatusGrid" || params.location.state.formname == "SSRMReeferStatusGrid")) {
            $('#globalLoader').show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetbookingDataByNumber?BookingNumber=' + params.location.state.reeferData[0].BookingNumber)
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.BookingDataByNumber[]>)
                .then(data => {
                    $('#globalLoader').hide();
                    if (data != null && data != undefined && data.length > 0) {
                        this.setState({ AllBooking: data }, () => { this.EditBooking(); });
                    }

                });

        }
        else
            this.setState({ renderHtml: this.dynamicRendering(1) });
    }
    EditBooking() {
        var isfound = this.state.AllBooking.filter(x => x.BookingNumber.toLowerCase() == self.props.location.state.reeferData[0].BookingNumber.toLowerCase());
        var BookingInfoDetails = emptyBookingDetails;
        BookingInfoDetails.Shipper = isfound[0].Shipper;
        BookingInfoDetails.Consignee = isfound[0].Consignee;
        BookingInfoDetails.ShipperCode = isfound[0].ShipperCode;
        BookingInfoDetails.POR = isfound[0].POR;
        BookingInfoDetails.POL = isfound[0].POL;
        BookingInfoDetails.POD = isfound[0].POD;
        BookingInfoDetails.VesselETD = isfound[0].VesselETD != null ? DateFormat(new Date(isfound[0].VesselETD), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.VesselETA = isfound[0].VesselETA != null ? DateFormat(new Date(isfound[0].VesselETA), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.BLNumber = isfound[0].BLNumber;
        BookingInfoDetails.ContractParty = isfound[0].ContractParty;
        BookingInfoDetails.Consolidation = isfound[0].Consolidation;
        BookingInfoDetails.Agent = isfound[0].Agent;
        BookingInfoDetails.VesselCode = isfound[0].VesselCode;
        BookingInfoDetails.VoyageNumber = isfound[0].VoyageNumber;
        BookingInfoDetails.Call = isfound[0].Call;
        BookingInfoDetails.Forwarder = isfound[0].Forwarder;
        BookingInfoDetails.Notify = isfound[0].Notify;
        BookingInfoDetails.BookingNumber = isfound[0].BookingNumber;
        BookingInfoDetails.DEL = isfound[0].DEL;
        BookingInfoDetails.BKCustomer = isfound[0].BKCustomer;
        if (isfound[0].LifecycleCd == 'L' || isfound[0].LifecycleCd == 'R' || isfound[0].LifecycleCd == 'D' || isfound[0].LifecycleCd == 'P') {
            var departingVVC = isfound[0].DepartingVVC.split('-');
            var depVoyage = departingVVC[0].trim().length > 0 ? departingVVC[0].trim() : '';
            var depCall = departingVVC[1].trim().length > 0 ? departingVVC[1].trim() : '';
            var arrivingVVC = isfound[0].ArrivingVVC.split('-');
            var arrVoyage = arrivingVVC[0].trim().length > 0 ? arrivingVVC[0].trim() : '';
            var arrCall = arrivingVVC[1].trim().length > 0 ? arrivingVVC[1].trim() : '';

            BookingInfoDetails.SelectedVoyage = depVoyage;
            BookingInfoDetails.SelectedCall = depCall;
            BookingInfoDetails.SelectedVesselCD = depVoyage != '' ? isfound[0].VoyageVesselCd : '';
            BookingInfoDetails.ArrSelectedVesselCD = arrVoyage != '' ? isfound[0].VoyageVesselCd : '';
            BookingInfoDetails.ArrSelectedVoyage = arrVoyage;
            BookingInfoDetails.ArrSelectedCall = arrCall;
        }
        BookingInfoDetails.CustomerAccessGroupIDLoaded = isfound[0].CustomerAccessGroupID;
        var BookingReefersData = emptyBookingReefers;
        BookingReefersData.BookingReefers = this.state.AllBooking.map(x => x.ReeferID).toString();
        BookingReefersData.SelectedBookingReefers = this.state.AllBooking.map(x => x.ReeferID).toString();
        BookingReefersData.ReeferwithUnitID = this.state.AllBooking.map(x => x.ReeferwithUnitID);
        var gridData = [];
        forEach(this.state.AllBooking, function (bookingItem) {
            
            if (bookingItem != "" && bookingItem != null) {

                var item = {
                    action: '', reeferId: bookingItem.ReeferID, cargoCare: bookingItem.CCProfileName, accessCodes: bookingItem.CustomerAccessGroupID, bookedTemperature: bookingItem.BookedTemperature,
                    bookedTemperatureQualifier: bookingItem.BookedTemperatureQualifier, bookedTemperatureMin: bookingItem.BookedTemperatureMin, bookedTemperatureMax: bookingItem.BookedTemperatureMax,
                    humidity: bookingItem.HumiditySetpoint, commodity: bookingItem.Commodity, STCC: bookingItem.STCC, HS: bookingItem.HSCode, gensetId: bookingItem.GensetId, ventSetting: bookingItem.VentSetting,
                    HVFlag: bookingItem.HighValueFlag, serviceLevel: bookingItem.ServiceLevel, CAFlag: bookingItem.CAFlag, O2Setpoint: bookingItem.O2Setpoint, O2SetpointMin: bookingItem.O2SetpointMin, O2SetpointMax: bookingItem.O2SetpointMax,
                    CO2Setpoint: bookingItem.CO2Setpoint, CO2SetpointMin: bookingItem.CO2SetpointMin, CO2SetpointMax: bookingItem.CO2SetpointMax, CTFlag: bookingItem.CTFlag,
                    CTDays: bookingItem.CTDays, USDAMaxTemperature: bookingItem.USDAMaxTemperature, postCTTemperature: bookingItem.PostCTTemperature, postCTTemperatureDeviation: bookingItem.PostCTTemperatureDeviation, postCTVentSetting: bookingItem.PostCTVentSetting,
                    UnitMasterId: bookingItem.UnitMasterID, CustomerAccessGroupIdsStr: ''
                };
                gridData.push(item);
            }
        });
        this.setState({ BookingDetails: BookingInfoDetails, BookingReefers: BookingReefersData, rowData: gridData, buttonState: false, formname: self.props.location.state.formname }, () => { this.setState({ renderHtml: this.dynamicRendering(1) }); });
    }
    dynamicRendering(tabPane: number) {
        if (tabPane == 1)
            return <SpecificBookingDetails
                formState={this.state}
                renderWizardPage={this.renderWizardPage.bind(this)}
            />
        else if (tabPane == 2)
            return <SpecificBookingReefers
                formState={this.state}
                prepareUpdateWithoutReefers={this.PrepareFinalSubmitWithoutReefers.bind(this)}
                renderWizardPage={this.renderWizardPage.bind(this)}
            />
        else if (tabPane == 3)
            return <SpecificBookingReeferCommonData
                formState={this.state}
                renderWizardPage={this.renderWizardPage.bind(this)}
            />
        else if (tabPane == 4)
            return <SpecificBookingReefersGridData
                formState={this.state}
                renderWizardPage={this.renderWizardPage.bind(this)}
                finishWizard={this.setFinalState.bind(this)}
            />
    }
    setFinalState(tabState: any, tabPaneFrom: number) {
        this.setState({ rowData: tabState.rowData, disassociaterowData: tabState.disassociaterowData }, () => { this.PrepareFinalSubmit(); });
    }
    ValidateFinalSubmitData() {
        var validationsummary = [];
        var strValaditionSummary = '';
        var reeferData = this.state.rowData;
        forEach(reeferData, function (reefer) {
            if (reefer.bookedTemperature != "" && reefer.bookedTemperature != null && reefer.bookedTemperatureMin != "" && reefer.bookedTemperatureMin != null && reefer.bookedTemperatureMax != "" && reefer.bookedTemperatureMax != null) {
                if (!(self.findInBetween(parseFloat(reefer.bookedTemperature), parseFloat(reefer.bookedTemperatureMin), parseFloat(reefer.bookedTemperatureMax)))) {
                    var strErr = `Reefer ${reefer.reeferId} Booked Temperature : ${reefer.bookedTemperature}  must be between Booked Temperature Min : ${reefer.bookedTemperatureMin} and Booked Temperature Max : ${reefer.bookedTemperatureMax}.`;
                    validationsummary.push(strErr);
                }
            }
            if (reefer.O2Setpoint != "" && reefer.O2Setpoint != null && reefer.O2SetpointMin != "" && reefer.O2SetpointMin != null && reefer.O2SetpointMax != "" && reefer.O2SetpointMax != null) {
                if (!(self.findInBetween(parseFloat(reefer.O2Setpoint), parseFloat(reefer.O2SetpointMin), parseFloat(reefer.O2SetpointMax)))) {
                    var strErr = `Reefer ${reefer.reeferId} O2Setpoint : ${reefer.O2Setpoint}  must be between O2Setpoint Min : ${reefer.O2SetpointMin} and O2Setpoint Max : ${reefer.O2SetpointMax}.`;
                    validationsummary.push(strErr);
                }
            }
            if (reefer.CO2Setpoint != "" && reefer.CO2Setpoint != null && reefer.CO2SetpointMin != "" && reefer.CO2SetpointMin != null && reefer.CO2SetpointMax != "" && reefer.CO2SetpointMax != null) {
                if (!(self.findInBetween(parseFloat(reefer.CO2Setpoint), parseFloat(reefer.CO2SetpointMin), parseFloat(reefer.CO2SetpointMax)))) {
                    var strErr = `Reefer ${reefer.reeferId} CO2Setpoint : ${reefer.CO2Setpoint}  must be between CO2Setpoint Min : ${reefer.CO2SetpointMin} and CO2Setpoint Max : ${reefer.CO2SetpointMax}.`;
                    validationsummary.push(strErr);
                }
            }
        });
        if (validationsummary != null && validationsummary.length > 0) {
            strValaditionSummary = validationsummary.join('<br/> ');
            RCNGWindow.ConfirmWindow.showConfirmBoxOK('Validation Error', strValaditionSummary, self.onOKSubmitValidation.bind(this));
            return false;
        }
        else {
            return true;
        }
    }
    findInBetween(val, min, max) {
        return (val >= min && val <= max);
    }
    onOKSubmitValidation() {
        $("#confirmPopUpModel .btn-close").click();
    }
    PrepareFinalSubmitWithoutReefers() {//RCNG-925
        $('#globalLoader').show();
        var bookingDetails = this.state.BookingDetails;
        var reeferData = [];
        //if (this.state.disassociaterowData != null && this.state.disassociaterowData != undefined && this.state.disassociaterowData.length > 0) {
        //    reeferData = [...this.state.rowData, ...this.state.disassociaterowData]
        //}
        var finalBookingData: server.booking = {
            bookingNumber: bookingDetails.BookingNumber, reefers: reeferData, shipper: bookingDetails.Shipper, shipperCode: bookingDetails.ShipperCode,
            consignee: bookingDetails.Consignee, agent: bookingDetails.Agent, vessel: bookingDetails.VesselCode,
            voyage: bookingDetails.VoyageNumber, POR: bookingDetails.POR, POL: bookingDetails.POL, POD: bookingDetails.POD, DEL: bookingDetails.DEL,
            vesselETD: bookingDetails.VesselETD != null ? bookingDetails.VesselETD.toString() : '', vesselETA: bookingDetails.VesselETA != null ? bookingDetails.VesselETA.toString() : '',
            BLNumber: bookingDetails.BLNumber, contractParty: bookingDetails.ContractParty, consolidation: bookingDetails.Consolidation, forwarder: bookingDetails.Forwarder, notify: bookingDetails.Notify
            , thirdpartyaccess: '', customeraccessgroupid: '', customer: bookingDetails.BKCustomer
        };
        var inputBody = JSON.stringify(finalBookingData);
        var url = Config.ApiBaseUrl + '/api/reeferstatus/SubmitReeferLevelBooking';
        var reefersCount = 0;
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: inputBody, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                $('#globalLoader').hide();
                if (data != null && data.toString() != "" && data.toString() == "Booking assigned successfully.") {


                    /*
                    if (this.state.formname == 'ReeferStatus') {
                        $("#contextMenuModel .close").click();
                        ReeferStatus.refreshReeferStatusGrid();
                    }
                    else if (this.state.formname == 'ReeferStatusGrid') {
                        $("#contextMenuModel .close").click();
                        ReeferStatusGrid.refreshDashboardGrid();
                    }
                    else if (this.state.formname == 'SSRMReeferStatusGrid') {
                        $("#contextMenuModel .close").click();
                        ReeferStatusSSRMGrid.refreshDashboardGrid();
                    }
                    */
                    if (this.state.formname == 'ReeferStatus' || this.state.formname == 'ReeferStatusGrid' || this.state.formname == 'SSRMReeferStatusGrid') {

                        (reefersCount == 1) ? PopupWindow.showErrorMessage("Edit Booking", 'Booking updated with ' + reefersCount + ' Reefer successfully')
                            : PopupWindow.showErrorMessage("Edit Booking", 'Booking updated with ' + reefersCount + ' Reefers successfully');

                        setTimeout(() => {
                            this.props.history.goBack();
                        }, 2000);
                    }
                    else {
                        (reefersCount == 1) ? RCNGWindow.ConfirmWindow.showConfirmBox('"' + bookingDetails.BookingNumber + '"' + ' updated with ' + reefersCount + ' Reefer successfully. Would you like to create another booking?', this.onOKSubmit.bind(this, data), this.closeConfirmation.bind(this))
                            : RCNGWindow.ConfirmWindow.showConfirmBox('"' + bookingDetails.BookingNumber + '"' + ' updated with ' + reefersCount + ' Reefers successfully. Would you like to create another booking?', this.onOKSubmit.bind(this, data), this.closeConfirmation.bind(this));
                    }

                    if (self.state.formname == 'ReeferStatusGrid')
                        setTimeout(() => { ReeferStatusGrid.refreshStatusGrid(); }, 4000)
                    if (self.state.formname == 'ReeferStatus')
                        setTimeout(() => { ReeferStatus.refreshStatusGrid(); }, 4000);
                    if (self.state.formname == 'SSRMReeferStatusGrid')
                        setTimeout(() => { ReeferStatusSSRMGrid.refreshDashboardGrid(); }, 4000)

                }
                else {
                    PopupWindow.showErrorMessage("Edit Booking", "Error while processing booking request.");
                }
            });
    }

    PrepareFinalSubmit() {
        var result = this.ValidateFinalSubmitData();
        if (result) {
            $('#globalLoader').show();
            var bookingDetails = this.state.BookingDetails;
            var reeferData = this.state.rowData;
            if (this.state.disassociaterowData != null && this.state.disassociaterowData != undefined && this.state.disassociaterowData.length > 0) {
                reeferData = [...this.state.rowData]  //RCNG-1070 Removed the disassociaterowData
            }

            var finalBookingData: server.booking = {
                bookingNumber: bookingDetails.BookingNumber, reefers: reeferData, shipper: bookingDetails.Shipper, shipperCode: bookingDetails.ShipperCode,
                consignee: bookingDetails.Consignee, customer: bookingDetails.BKCustomer, agent: bookingDetails.Agent, vessel: bookingDetails.VesselCode,
                voyage: bookingDetails.VoyageNumber, POR: bookingDetails.POR, POL: bookingDetails.POL, POD: bookingDetails.POD, DEL: bookingDetails.DEL,
                vesselETD: bookingDetails.VesselETD != null ? bookingDetails.VesselETD.toString() : '', vesselETA: bookingDetails.VesselETA != null ? bookingDetails.VesselETA.toString() : '',
                BLNumber: bookingDetails.BLNumber, contractParty: bookingDetails.ContractParty, consolidation: bookingDetails.Consolidation, forwarder: bookingDetails.Forwarder, notify: bookingDetails.Notify,
                thirdpartyaccess: this.state.CommonBookingData.ThirdPartyAccess,
                customeraccessgroupid: this.state.BookingDetails.CustomerAccessGroupIDLoaded
            };
            var inputBody = JSON.stringify(finalBookingData);
            var url = Config.ApiBaseUrl + '/api/reeferstatus/SubmitReeferLevelBooking';
            var reefersCount = this.state.rowData.length; // RCNG 361
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: inputBody, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            RCUtils.fetchRetry(request)
                .then(RCUtils.handleResponse)
                .then(response => response.json() as Promise<any>)
                .then(data => {
                    $('#globalLoader').hide();
                    if (data != null && data.toString() != "" && data.toString() == "Booking assigned successfully.") {


                        /*
                        if (this.state.formname == 'ReeferStatus') {
                            $("#contextMenuModel .close").click();
                            ReeferStatus.refreshReeferStatusGrid();
                        }
                        else if (this.state.formname == 'ReeferStatusGrid') {
                            $("#contextMenuModel .close").click();
                            ReeferStatusGrid.refreshDashboardGrid();
                        }
                        else if (this.state.formname == 'SSRMReeferStatusGrid') {
                            $("#contextMenuModel .close").click();
                            ReeferStatusSSRMGrid.refreshDashboardGrid();
                        }
                        */
                        if (this.state.formname == 'ReeferStatus' || this.state.formname == 'ReeferStatusGrid' || this.state.formname == 'SSRMReeferStatusGrid') {

                            (reefersCount == 1) ? PopupWindow.showErrorMessage("Edit Booking", 'Booking updated with ' + reefersCount + ' Reefer successfully')
                                : PopupWindow.showErrorMessage("Edit Booking", 'Booking updated with ' + reefersCount + ' Reefers successfully');

                            setTimeout(() => {
                                this.props.history.goBack();
                            }, 2000);
                        }
                        else {
                            (reefersCount == 1) ? RCNGWindow.ConfirmWindow.showConfirmBox('"' + bookingDetails.BookingNumber + '"' + ' updated with ' + reefersCount + ' Reefer successfully. Would you like to create another booking?', this.onOKSubmit.bind(this, data), this.closeConfirmation.bind(this))
                                : RCNGWindow.ConfirmWindow.showConfirmBox('"' + bookingDetails.BookingNumber + '"' + ' updated with ' + reefersCount + ' Reefers successfully. Would you like to create another booking?', this.onOKSubmit.bind(this, data), this.closeConfirmation.bind(this));
                        }

                        if (self.state.formname == 'ReeferStatusGrid')
                            setTimeout(() => { ReeferStatusGrid.refreshStatusGrid(); }, 4000)
                        if (self.state.formname == 'ReeferStatus')
                            setTimeout(() => { ReeferStatus.refreshStatusGrid(); }, 4000);
                        if (self.state.formname == 'SSRMReeferStatusGrid')
                            setTimeout(() => { ReeferStatusSSRMGrid.refreshDashboardGrid(); }, 4000)

                    }
                    else {
                        PopupWindow.showErrorMessage("Edit Booking", "Error while processing booking request.");
                    }
                });
        }
    }
    onOKSubmit(param: any) {
        var emptyBookingDetails: server.BookingDetails = {
            Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '', VesselETD: null, VesselETA: null, BLNumber: '', ContractParty: '', Consolidation: '',
            Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
            SelectedVesselCD: '',
            SelectedCall: '',
            SelectedVoyage: '',
            ArrSelectedVesselCD: '',
            ArrSelectedCall: '',
            ArrSelectedVoyage: '', userInput: 0,CustomerAccessGroupIDLoaded:'',
            BKCustomer:''
        };
        var emptyCommonBookingData: server.CommonBookingData = {
            ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: '', BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
            HighValueCargo: 'none', CargoCareProfile: '', ThirdPartyAccess: '', CACTNotRequired: false, CTRequire: false, CARequire: false, CACTDifferByReefer: false,
            CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
            O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName: ''
        };
        var emptyBookingReefers: server.BookingSearchDetails = {
            BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [], BookingNumber: []
        }
        this.setState({
            currentTab: 1, CommonBookingData: emptyCommonBookingData, rowData: [], BookingDetails: emptyBookingDetails, BookingReefers: emptyBookingReefers, isEdit: false, tabFrom: 1,
            AllBooking: [],
            BookingCount: 0,
            BookingType: 'New Booking',
            IsOpen: 'New',
            buttonState: false
        }, () => { this.props.history.push('/Newbookingassign'); RCNGWindow.ConfirmWindow.close(); });

    }

    RedirectToFirstTab() {
        this.setState({ renderHtml: this.dynamicRendering(1) }, () => { this.setActiveAndInactiveOld(1, 0); RCNGWindow.ConfirmWindow.close(); });
    }
    closeConfirmation() {
        var emptyBookingDetails: server.BookingDetails = {
            Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '', VesselETD: null, VesselETA: null, BLNumber: '', ContractParty: '', Consolidation: '',
            Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
            SelectedVesselCD: '',
            SelectedCall: '',
            SelectedVoyage: '',
            ArrSelectedVesselCD: '',
            ArrSelectedCall: '',
            ArrSelectedVoyage: '', userInput: 0,CustomerAccessGroupIDLoaded:'',
            BKCustomer:''
        };
        var emptyCommonBookingData: server.CommonBookingData = {
            ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: '', BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
            HighValueCargo: 'none', CargoCareProfile: '', ThirdPartyAccess: '', CACTNotRequired: false, CTRequire: false, CARequire: false, CACTDifferByReefer: false,
            CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
            O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName: ''
        };
        var emptyBookingReefers: server.BookingSearchDetails = {
            BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [],BookingNumber:[]
        }
        this.setState({
            currentTab: 1, CommonBookingData: emptyCommonBookingData, rowData: [], BookingDetails: emptyBookingDetails, BookingReefers: emptyBookingReefers, isEdit: false, tabFrom: 1,
            AllBooking: [],
            BookingCount: 0,
            BookingType: 'New Booking',
            IsOpen: 'New',
            buttonState: false
        }, () => {
            RCNGWindow.ConfirmWindow.close(); this.props.history.push('/home');
            if (JSON.parse(sessionStorage.getItem('SSRM'))) {
                setTimeout(() => { ReeferStatusSSRMGrid.refreshDashboardGrid(); }, 5000);
            } else {
                setTimeout(() => { ReeferStatusGrid.refreshStatusGrid(); }, 5000);
            }
        });
    }

    setActiveAndInactiveOld(TabToActive: number, TabToInactive: number) {

        if (TabToInactive > 0)
            document.getElementById("atab" + TabToInactive).classList.remove("active");

        document.getElementById("atab" + TabToActive).classList.add("active");
    }

    renderWizardPage(tabPane: number, tabState: any, tabPaneFrom: number) {
        this.setState({ tabFrom: tabPaneFrom });
        this.setActiveAndInactiveOld(tabPane, tabPaneFrom);
        switch (tabPane) {
            case 1:
                var newBookingDetails = emptyBookingDetails;
                newBookingDetails.Shipper = tabState.BookingDetails.Shipper;
                newBookingDetails.Consignee = tabState.BookingDetails.Consignee;
                newBookingDetails.ShipperCode = tabState.BookingDetails.ShipperCode;
                newBookingDetails.POR = tabState.BookingDetails.POR;
                newBookingDetails.POL = tabState.BookingDetails.POL;
                newBookingDetails.POD = tabState.BookingDetails.POD;
                newBookingDetails.VesselETD = tabState.BookingDetails.VesselETD;
                newBookingDetails.VesselETA = tabState.BookingDetails.VesselETA;
                newBookingDetails.BLNumber = tabState.BookingDetails.BLNumber;
                newBookingDetails.ContractParty = tabState.BookingDetails.ContractParty;
                newBookingDetails.Consolidation = tabState.BookingDetails.Consolidation;
                newBookingDetails.Agent = tabState.BookingDetails.Agent;
                newBookingDetails.VesselCode = tabState.BookingDetails.VesselCode;
                newBookingDetails.VoyageNumber = tabState.BookingDetails.VoyageNumber;
                newBookingDetails.Call = tabState.BookingDetails.Call;
                newBookingDetails.Forwarder = tabState.BookingDetails.Forwarder;
                newBookingDetails.Notify = tabState.BookingDetails.Notify;
                newBookingDetails.BookingNumber = tabState.BookingDetails.BookingNumber;
                newBookingDetails.DEL = tabState.BookingDetails.DEL;
                newBookingDetails.SelectedVesselCD = tabState.BookingDetails.SelectedVesselCD;
                newBookingDetails.SelectedCall = tabState.BookingDetails.SelectedCall;
                newBookingDetails.SelectedVoyage = tabState.BookingDetails.SelectedVoyage;
                newBookingDetails.ArrSelectedVesselCD = tabState.BookingDetails.ArrSelectedVesselCD;
                newBookingDetails.ArrSelectedCall = tabState.BookingDetails.ArrSelectedCall;
                newBookingDetails.ArrSelectedVoyage = tabState.BookingDetails.ArrSelectedVoyage;
                newBookingDetails.userInput = tabState.BookingDetails.userInput;
                newBookingDetails.IsVVCModified = tabState.BookingDetails.IsVVCModified;
                newBookingDetails.BKCustomer = tabState.BookingDetails.BKCustomer;
                var newBookingReefersDetails = emptyBookingReefers;
                newBookingReefersDetails.BookingReefers = tabState.SelectedReefer;
                newBookingReefersDetails.SelectedBookingReefers = tabState.ReeferIds;
                newBookingReefersDetails.ReeferwithUnitID = tabState.ReeferwithUnitID;
                newBookingReefersDetails.BookingNumber = tabState.BookingNumber;
                this.setState({ BookingDetails: newBookingDetails, BookingReefers: newBookingReefersDetails }, () => { this.setState({ renderHtml: this.dynamicRendering(tabPane), currentTab: tabPane }); });
                break;
            case 2:
                var newBookingDetails = emptyBookingDetails;
                newBookingDetails.Shipper = tabState.BookingDetails.Shipper;
                newBookingDetails.Consignee = tabState.BookingDetails.Consignee;
                newBookingDetails.ShipperCode = tabState.BookingDetails.ShipperCode;
                newBookingDetails.POR = tabState.BookingDetails.POR;
                newBookingDetails.POL = tabState.BookingDetails.POL;
                newBookingDetails.POD = tabState.BookingDetails.POD;
                newBookingDetails.VesselETD = tabState.BookingDetails.VesselETD;
                newBookingDetails.VesselETA = tabState.BookingDetails.VesselETA;
                newBookingDetails.BLNumber = tabState.BookingDetails.BLNumber;
                newBookingDetails.ContractParty = tabState.BookingDetails.ContractParty;
                newBookingDetails.Consolidation = tabState.BookingDetails.Consolidation;
                newBookingDetails.Agent = tabState.BookingDetails.Agent;
                newBookingDetails.VesselCode = tabState.BookingDetails.VesselCode;
                newBookingDetails.VoyageNumber = tabState.BookingDetails.VoyageNumber;
                newBookingDetails.Call = tabState.BookingDetails.Call;
                newBookingDetails.Forwarder = tabState.BookingDetails.Forwarder;
                newBookingDetails.Notify = tabState.BookingDetails.Notify;
                newBookingDetails.BookingNumber = tabState.BookingDetails.BookingNumber;
                newBookingDetails.DEL = tabState.BookingDetails.DEL;
                newBookingDetails.SelectedVesselCD = tabState.BookingDetails.SelectedVesselCD;
                newBookingDetails.SelectedCall = tabState.BookingDetails.SelectedCall;
                newBookingDetails.SelectedVoyage = tabState.BookingDetails.SelectedVoyage;
                newBookingDetails.ArrSelectedVesselCD = tabState.BookingDetails.ArrSelectedVesselCD;
                newBookingDetails.ArrSelectedCall = tabState.BookingDetails.ArrSelectedCall;
                newBookingDetails.ArrSelectedVoyage = tabState.BookingDetails.ArrSelectedVoyage;
                newBookingDetails.userInput = tabState.BookingDetails.userInput;
                newBookingDetails.BKCustomer = tabState.BookingDetails.BKCustomer;
                newBookingDetails.IsVVCModified = tabState.BookingDetails.IsVVCModified;
                var newBookingReefersDetails = emptyBookingReefers;
                newBookingReefersDetails.BookingReefers = tabState.BookingReefers.BookingReefers;
                newBookingReefersDetails.SelectedBookingReefers = tabState.BookingReefers.SelectedBookingReefers;
                newBookingReefersDetails.ReeferwithUnitID = tabState.BookingReefers.ReeferwithUnitID;
                newBookingReefersDetails.BookingNumber = tabState.BookingReefers.BookingNumber;
                var Edit = this.state.isEdit;
                var BookingAll = this.state.AllBooking;
                var CountBooking = this.state.BookingCount;
                this.setState({
                    BookingDetails: newBookingDetails, BookingReefers: newBookingReefersDetails, rowData: tabState.rowData,
                    isEdit: tabState.isBookingEdit != undefined ? tabState.isBookingEdit : Edit,
                    AllBooking: tabState.BookingList != undefined ? tabState.BookingList : BookingAll,
                    BookingCount: tabState.isAllBooking != undefined ? tabState.isAllBooking : CountBooking
                }, () => { this.setState({ renderHtml: this.dynamicRendering(tabPane), currentTab: tabPane }); });
                break;
            case 3:
                var newBookingReefersDetails = emptyBookingReefers;
                newBookingReefersDetails.BookingReefers = tabState.BookingReefers.BookingReefers;
                newBookingReefersDetails.SelectedBookingReefers = tabState.BookingReefers.SelectedBookingReefers;
                newBookingReefersDetails.ReeferwithUnitID = tabState.BookingReefers.ReeferwithUnitID;
                newBookingReefersDetails.BookingNumber = tabState.BookingReefers.BookingNumber;


                var emptyCommonBookingData: server.CommonBookingData = {
                    ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: '', BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
                    HighValueCargo: tabState.CommonBookingData.HighValueCargo != undefined ? tabState.CommonBookingData.HighValueCargo : 'none', CargoCareProfile: '', ThirdPartyAccess: '', CACTNotRequired: tabState.CommonBookingData.CACTNotRequired != undefined ? tabState.CommonBookingData.CACTNotRequired : false, CTRequire: tabState.CommonBookingData.CTRequire != undefined ? tabState.CommonBookingData.CTRequire : false, CARequire: tabState.CommonBookingData.CARequire != undefined ? tabState.CommonBookingData.CARequire : false, CACTDifferByReefer: tabState.CommonBookingData.CACTDifferByReefer != undefined ? tabState.CommonBookingData.CACTDifferByReefer : false,
                    CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
                    O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName: ''
                };

                var bookedTemperatureCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.bookedTemperature === item.bookedTemperature) === i
                );
                if (bookedTemperatureCount.length > 0 && bookedTemperatureCount.length == 1) {
                    emptyCommonBookingData.BookedTemperature = bookedTemperatureCount[0].bookedTemperature;
                }
                var bookedTemperatureMaxCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.bookedTemperatureMax === item.bookedTemperatureMax) === i
                );
                if (bookedTemperatureMaxCount.length > 0 && bookedTemperatureMaxCount.length == 1) {
                    emptyCommonBookingData.BookedTemperatureMax = bookedTemperatureMaxCount[0].bookedTemperatureMax;
                }
                var bookedTemperatureMinCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.bookedTemperatureMin === item.bookedTemperatureMin) === i
                );
                if (bookedTemperatureMinCount.length > 0 && bookedTemperatureMinCount.length == 1) {
                    emptyCommonBookingData.BookedTemperatureMin = bookedTemperatureMinCount[0].bookedTemperatureMin;
                }


                var bookedTemperatureQualifierCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.bookedTemperatureQualifier === item.bookedTemperatureQualifier) === i
                );
                if (bookedTemperatureQualifierCount.length > 0 && bookedTemperatureQualifierCount.length == 1) {
                    emptyCommonBookingData.BookedTemperatureUnit = bookedTemperatureQualifierCount[0].bookedTemperatureQualifier;
                }

                var humidityCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.humidity === item.humidity) === i
                );
                if (humidityCount.length > 0 && humidityCount.length == 1) {
                    emptyCommonBookingData.HumiditySetPoint = humidityCount[0].humidity;
                }
                var ventSettingCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.ventSetting === item.ventSetting) === i
                );
                if (ventSettingCount.length > 0 && ventSettingCount.length == 1) {
                    emptyCommonBookingData.VentSettings = ventSettingCount[0].ventSetting;
                }
                var gensetIdCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.gensetId === item.gensetId) === i
                );
                if (gensetIdCount.length > 0 && gensetIdCount.length == 1) {
                    emptyCommonBookingData.GensetId = gensetIdCount[0].gensetId;
                }
                var commodityCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.commodity === item.commodity) === i
                );
                if (commodityCount.length > 0 && commodityCount.length == 1) {
                    emptyCommonBookingData.CommodityName = commodityCount[0].commodity;
                }

                var STCCCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.STCC === item.STCC) === i
                );
                if (STCCCount.length > 0 && STCCCount.length == 1) {
                    emptyCommonBookingData.STCC = STCCCount[0].STCC;
                }


                var HSCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.HS === item.HS) === i
                );
                if (HSCount.length > 0 && HSCount.length == 1) {
                    emptyCommonBookingData.HSCode = HSCount[0].HS;
                }
                var serviceLevelCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.serviceLevel === item.serviceLevel) === i
                );
                if (serviceLevelCount.length > 0 && serviceLevelCount.length == 1) {
                    emptyCommonBookingData.ServiceLevel = serviceLevelCount[0].serviceLevel;
                }
                var HVFlagCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.HVFlag === item.HVFlag) === i
                );
                if (HVFlagCount.length > 0 && HVFlagCount.length == 1) {
                    emptyCommonBookingData.HighValueCargo = HVFlagCount[0].HVFlag;
                }
                var cargoCareCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.cargoCare === item.cargoCare) === i
                );
                if (cargoCareCount.length > 0 && cargoCareCount.length == 1) {
                    emptyCommonBookingData.CargoCareProfile = cargoCareCount[0].cargoCare;
                }
                var accessCodesCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.accessCodes === item.accessCodes) === i
                );
                if (accessCodesCount.length > 0 && accessCodesCount.length == 1) {
                    emptyCommonBookingData.ThirdPartyAccess = accessCodesCount[0].accessCodes;
                }
                var CAFlagCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.CAFlag === item.CAFlag) === i
                );
                if (CAFlagCount.length > 0 && CAFlagCount.length == 1) {
                    emptyCommonBookingData.CARequire = CAFlagCount[0].CAFlag;
                }
                var CTFlagCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.CTFlag === item.CTFlag) === i
                );
                if (CTFlagCount.length > 0 && CTFlagCount.length == 1) {
                    emptyCommonBookingData.CTRequire = CTFlagCount[0].CTFlag;
                }
                var O2SetpointCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.O2Setpoint === item.O2Setpoint) === i
                );
                if (O2SetpointCount.length > 0 && O2SetpointCount.length == 1) {
                    emptyCommonBookingData.O2SetPoint = O2SetpointCount[0].O2Setpoint;
                }
                var O2SetpointMaxCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.O2SetpointMax === item.O2SetpointMax) === i
                );
                if (O2SetpointMaxCount.length > 0 && O2SetpointMaxCount.length == 1) {
                    emptyCommonBookingData.O2Max = O2SetpointMaxCount[0].O2SetpointMax;
                }

                var O2SetpointMinCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.O2SetpointMin === item.O2SetpointMin) === i
                );
                if (O2SetpointMinCount.length > 0 && O2SetpointMinCount.length == 1) {
                    emptyCommonBookingData.O2Min = O2SetpointMinCount[0].O2SetpointMin;
                }
                var CO2SetpointCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.CO2Setpoint === item.CO2Setpoint) === i
                );
                if (CO2SetpointCount.length > 0 && CO2SetpointCount.length == 1) {
                    emptyCommonBookingData.CO2SetPoint = CO2SetpointCount[0].CO2Setpoint;
                }
                var CO2SetpointMaxCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.CO2SetpointMax === item.CO2SetpointMax) === i
                );
                if (CO2SetpointMaxCount.length > 0 && CO2SetpointMaxCount.length == 1) {
                    emptyCommonBookingData.CO2Max = CO2SetpointMaxCount[0].CO2SetpointMax;
                }
                var CO2SetpointMinCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.CO2SetpointMin === item.CO2SetpointMin) === i
                );
                if (CO2SetpointMinCount.length > 0 && CO2SetpointMinCount.length == 1) {
                    emptyCommonBookingData.CO2Min = CO2SetpointMinCount[0].CO2SetpointMin;
                }
                var CTDaysCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.CTDays === item.CTDays) === i
                );
                if (CTDaysCount.length > 0 && CTDaysCount.length == 1) {
                    emptyCommonBookingData.CTDays = CTDaysCount[0].CTDays;
                }
                var USDAMaxTemperatureCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.USDAMaxTemperature === item.USDAMaxTemperature) === i
                );
                if (USDAMaxTemperatureCount.length > 0 && USDAMaxTemperatureCount.length == 1) {
                    emptyCommonBookingData.CTMaxTemperature = USDAMaxTemperatureCount[0].USDAMaxTemperature;
                }
                var postCTTemperatureCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.postCTTemperature === item.postCTTemperature) === i
                );
                if (postCTTemperatureCount.length > 0 && postCTTemperatureCount.length == 1) {
                    emptyCommonBookingData.PostCTTemperature = postCTTemperatureCount[0].postCTTemperature;
                }
                var postCTTemperatureCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.postCTTemperature === item.postCTTemperature) === i
                );
                if (postCTTemperatureCount.length > 0 && postCTTemperatureCount.length == 1) {
                    emptyCommonBookingData.PostCTTemperature = postCTTemperatureCount[0].postCTTemperature;
                }
                var postCTTemperatureDeviationCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.postCTTemperatureDeviation === item.postCTTemperatureDeviation) === i
                );
                if (postCTTemperatureDeviationCount.length > 0 && postCTTemperatureDeviationCount.length == 1) {
                    emptyCommonBookingData.PostCTTemperatureRange = postCTTemperatureDeviationCount[0].postCTTemperatureDeviation;
                }
                var postCTVentSettingCount = tabState.rowData.filter(
                    (item, i, arr) => arr.findIndex(t => t.postCTVentSetting === item.postCTVentSetting) === i
                );
                if (postCTVentSettingCount.length > 0 && postCTVentSettingCount.length == 1) {
                    emptyCommonBookingData.PostCTVentSettings = postCTVentSettingCount[0].postCTVentSetting;
                }

                this.setState({ BookingReefers: newBookingReefersDetails, CommonBookingData: emptyCommonBookingData, rowData: tabState.rowData }, () => { this.setState({ renderHtml: this.dynamicRendering(tabPane), currentTab: tabPane }); });
                break;
            case 4:
                this.setState({ CommonBookingData: tabState.CommonBookingData, rowData: tabState.rowData, CargoCareProfiles: tabState.CargoCareProfiles, Thirdparty: tabState.Thirdparty, RefTemperatureUnit: tabState.RefTemperatureUnit }, () => { this.setState({ renderHtml: this.dynamicRendering(tabPane), currentTab: tabPane }); });
                break;
        }
    }
    backScreen() {
        if (this.state.currentTab == 2) {
            SpecificBookingReefers.BackScreen();
        }
        else if (this.state.currentTab == 3) {
            //Test.BackScreen();
            SpecificBookingReeferCommonData.BackScreen();
        }
        else if (this.state.currentTab == 4) {
            SpecificBookingReefersGridData.BackScreen();
        }

    }

    nextScreen() {
        if (this.state.currentTab == 1) {
            SpecificBookingDetails.NextScreen();
        }
        else if (this.state.currentTab == 2) {
            SpecificBookingReefers.NextScreen();
        }
        else if (this.state.currentTab == 3) {
            SpecificBookingReeferCommonData.NextScreen();
        }
        else if (this.state.currentTab == 4) {
            SpecificBookingReefersGridData.NextScreen();
        }

    }


    cancelWizard() {
        var emptyBookingDetails: server.BookingDetails = {
            Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '', VesselETD: null, VesselETA: null, BLNumber: '', ContractParty: '', Consolidation: '',
            Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
            SelectedVesselCD: '',
            SelectedCall: '',
            SelectedVoyage: '',
            ArrSelectedVesselCD: '',
            ArrSelectedCall: '',
            ArrSelectedVoyage: '', userInput: 0,CustomerAccessGroupIDLoaded:'',
            BKCustomer:''
        };
        var emptyCommonBookingData: server.CommonBookingData = {
            ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: '', BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
            HighValueCargo: 'none', CargoCareProfile: '', ThirdPartyAccess: '', CACTNotRequired: false, CTRequire: false, CARequire: false, CACTDifferByReefer: false,
            CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
            O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName: ''
        };
        var emptyBookingReefers: server.BookingSearchDetails = {
            BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [], BookingNumber: []
        }
        if (this.state.formname == 'ReeferStatus' || this.state.formname == 'ReeferStatusGrid' || this.state.formname == 'SSRMReeferStatusGrid') {
            this.setState({
                currentTab: 1, CommonBookingData: emptyCommonBookingData, rowData: [], BookingDetails: emptyBookingDetails, BookingReefers: emptyBookingReefers, isEdit: false, tabFrom: 1,
                AllBooking: [],
                BookingCount: 0,
                BookingType: 'New Booking',
                IsOpen: 'New',
                buttonState: false
            }, () => { RCNGWindow.ConfirmWindow.close(); this.props.history.goBack(); });
        }
        else {
            this.setState({
                currentTab: 1, CommonBookingData: emptyCommonBookingData, rowData: [], BookingDetails: emptyBookingDetails, BookingReefers: emptyBookingReefers, isEdit: false, tabFrom: 1,
                AllBooking: [],
                BookingCount: 0,
                BookingType: 'New Booking',
                IsOpen: 'New',
                buttonState: false
            }, () => { RCNGWindow.ConfirmWindow.close(); this.props.history.push('/home'); });
        }
    }
    finishWizard() {
        SpecificBookingReefersGridData.finishWizard();
    }
    static UpdateBookingType(Type: any) {
        self.setState({ BookingType: Type });
    }
    static UpdateButtonStyle(State: any) {
        self.setState({ buttonState: State });
    }
    public render() {
        return <div>
            <div className='innerpages-heading'>Edit Booking</div>

            <div id='BookingWizard'>
                <div id='BookingTabsHeight'>
                    <div className='newBootstrapWizard deploymentWizard' id='smartwizard'>
                        <ul id="SubscriptionMenu" className="nav nav-pills">
                            <li><a href='#' data-bs-toggle="pill" className="nav-link active" id="atab1">Booking Data</a></li>
                            <li><a href='#' data-bs-toggle="pill" className="nav-link" id="atab2">Reefers List</a></li>
                            <li><a href='#' data-bs-toggle="pill" className="nav-link" id="atab3">Common Reefer Data</a></li>
                            <li><a href='#' data-bs-toggle="pill" className="nav-link" id="atab4">Reefer-Specific Data</a></li>
                        </ul>
                    </div>
                    <div className="tab-content">
                        {this.state.renderHtml}
                    </div>

                </div>

                    <div className="row">

                        <div className="col-md-12">


                        <div className='float-md-end me-3'>
                            <button type='button' className='btn btn btn-primary me-2' onClick={this.cancelWizard.bind(this)}>Cancel</button>
                                {
                                    this.state.currentTab != 1 ? <button type='button' className='btn btn btn-primary me-2' onClick={this.backScreen.bind(this)}>Back</button> : ''
                                }
                                {
                                    this.state.currentTab == 4 ? <button type='button' className='btn btn btn-primary me-2' onClick={this.finishWizard.bind(this)}>Save</button>
                                        :
                                        <button type='button' className='btn btn btn-primary me-2' disabled={this.state.buttonState} onClick={this.nextScreen.bind(this)}>Next</button>
                                }
                               
                            </div>

                        </div>
                    </div>
               
            </div>

        </div>;
    }
}